import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLatest } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

export interface Manifestacao {
  idManifestacao: string;
  protocolo: string;
  titulo: string;
  descricao: string;
  tipoManifestacao: string;
  status: string;
  dataAbertura: string;
  dataAberturaFormatada: string;
  idUsuario: string;
  nomeUsuario: string;
  emailUsuario: string;
  cpfUsuario: string;
  telefoneUsuario: string;
  enderecoUsuario: {
    tipoLogradouro: string;
    logradouro: string;
    numero: string;
    complemento: string;
    bairro: string;
    municipio: string;
    uf: string;
    cep: string;
  };
  mensagens: {
    idMensagem: string;
    nomeUsuario: string;
    cpfUsuario: string;
    usuarioManifestante: boolean;
    texto: string;
    horario: string;
  }[];
  imagem?: string;
  latitude: number;
  longitude: number;
}

export interface ObterManifestacaoPorIdRequest {
  id: string;
  onSuccess?: (data: Manifestacao) => void;
}

interface State {
  isRequesting: boolean;
  successPayload: Manifestacao | null;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  successPayload: null,
  errors: []
};

const slice = createSlice({
  name: "ouvidoria.manifestacoes@obterManifestacaoPorId",
  initialState,
  reducers: {
    obterManifestacaoPorId: (
      state,
      _action: PayloadAction<ObterManifestacaoPorIdRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    obterManifestacaoPorIdSuccess: (
      state,
      action: PayloadAction<Manifestacao>
    ): void => {
      state.isRequesting = false;
      state.successPayload = action.payload;
    },
    obterManifestacaoPorIdFailed: (
      state,
      action: PayloadAction<string[]>
    ): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* worker(params: {
  type: string;
  payload: ObterManifestacaoPorIdRequest;
}) {
  const { id, onSuccess } = params.payload;
  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.get,
      `api/v1/cidadao/ouvidoria/manifestacoes/detalhe/${id}`
    );
    const { data }: { data: any } = response;

    yield put(obterManifestacaoPorIdSuccess(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    yield put(obterManifestacaoPorIdFailed(formatError(error)));
  }
}

export const {
  obterManifestacaoPorId,
  obterManifestacaoPorIdSuccess,
  obterManifestacaoPorIdFailed
} = slice.actions;
export const { reducer } = slice;
export const saga = takeLatest(obterManifestacaoPorId.type, worker);
